<template>
  <div class="home-gerais">
    <mf-loading-dialog :loading="$apollo.loading">
      <v-container class="pa-0" fluid>
        <v-card class="my-3 px-6">
          <v-card-title>
            <span class="section-title">Lojas</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="pt-0" cols="g">
                <label class="detail-title">App Store</label>
                <v-text-field
                  v-model.lazy="store_links__app_store"
                  class="mb-0"
                  outlined
                  name="store_links__app_store"
                  :placeholder="externalLinkPlaceholders('store_links__app_store')"
                  @paste="handlePaste"
                />
              </v-col>

              <v-col class="pt-0" cols="g">
                <label class="detail-title">Play Store</label>
                <v-text-field
                  v-model.lazy="store_links__play_store"
                  class="mb-0"
                  outlined
                  name="store_links__play_store"
                  :placeholder="externalLinkPlaceholders('store_links__play_store')"
                  @paste="handlePaste"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-3 pt-0 pr-3">
            <v-spacer />
            <mf-button :loading="saving" label="Atualizar dados de stores" @click="updateStoreLinksConfiguration" />
          </v-card-actions>
        </v-card>
      </v-container>
    </mf-loading-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { externalLinkPrefixValidation, externalLinkPlaceholders } from '@/helpers/externalLinks.js'

const QUERY_CONFIGURATION = gql`
  query Configuration {
    configuration {
      store_links {
        app_store
        play_store
      }
    }
  }
`

const MUTATION_STORES = gql`
  mutation UpdateConfiguration($store_links: StoreLinksInput) {
    updateConfiguration(store_links: $store_links)
  }
`

export default {
  data: () => ({
    saving: false,
    store_links: {
      app_store: '',
      play_store: '',
    },
  }),
  computed: {
    store_links__app_store: {
      get() {
        return this.store_links?.app_store
      },
      set(value) {
        this.store_links.app_store = value
      },
    },
    store_links__play_store: {
      get() {
        return this.store_links?.play_store
      },
      set(value) {
        this.store_links.play_store = value
      },
    },
  },
  apollo: {
    configuration: {
      query: QUERY_CONFIGURATION,
      fetchPolicy: 'no-cache',
      update({ configuration }) {
        if (!configuration) return {}
        this.store_links.app_store = configuration?.store_links?.app_store || ''
        this.store_links.play_store = configuration?.store_links?.play_store || ''
        return configuration
      },
      notifyOnNetworkStatusChange: true,
    },
  },
  mounted() {
    document.title = 'Configurações do Aplicativo'
  },
  methods: {
    externalLinkPlaceholders,
    handlePaste(event) {
      const clipboardData = event.clipboardData.getData('text')
      if (clipboardData.match(/https/g || [])) {
        this[event.target.name] = clipboardData
      } else {
        this[event.target.name] = externalLinkPrefixValidation(clipboardData, event.target.name)
      }
      event.preventDefault()
    },
    async updateStoreLinksConfiguration() {
      const confirmed = await this.$confirm({
        title: 'Atualizar configurações',
        message: 'Tem certeza que deseja atualizar as configurações de lojas mobile?',
        confirmText: 'Salvar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.saving = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_STORES,
          variables: {
            store_links: {
              app_store: this.store_links.app_store,
              play_store: this.store_links.play_store,
            },
          },
        })
        this.$apollo.queries.configuration.refresh()
      } catch (e) {
        this.$snackbar({ message: 'Falha ao comunicar com o servidor.' })
      }
      this.saving = false
    },
  },
}
</script>

<style lang="scss">
.home-gerais {
  .section-title {
    font-size: 20px;
    font-weight: bold;
  }
  .detail-title {
    opacity: 0.8;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 0.24px;
    color: $preto;
    margin-bottom: 8px;
  }
}
</style>
